import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const endSearchSession = action(
    'END_SEARCH_SESSION_NEXT',
    (scenarioId: SearchScenarioId, actionSource?: string) => ({
        scenarioId,
        actionSource,
    })
);

export default endSearchSession;
